import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/apiFetch";

export interface ExamCatalogEntry {
  id: string;
  name: string;
  region: string;
  category: string;
  prepWeeksMin: number;
  prepWeeksMax: number;
}

export function useExamCatalog() {
  const [exams, setExams] = useState<ExamCatalogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch("/api/v1/exam-catalog")
      .then(r => r.json())
      .then(d => setExams(d.exams ?? []))
      .catch(() => setExams([]))
      .finally(() => setLoading(false));
  }, []);

  return { exams, loading };
}
